import { getFirestore, doc, collection, query, where, addDoc, getDoc, getDocs, updateDoc, setDoc, onSnapshot, deleteDoc, documentId } from "firebase/firestore"

let db = getFirestore()
let collectionName = 'appdata/'

function docToInstance(document) {
  let data = document.data()
  return !data ? null : new Appdata(document.id, data.application, data.parameters)
}

export default class Appdata {
  constructor(id, application, parameters) {
    this.id = id
    this.application = application
    this.parameters = parameters
  }

  static listenByApplication(appId, callback) {
    let docQuery = query(collection(db, collectionName), where('application', '==', appId))

    return onSnapshot(docQuery, snapshot => {
      let appdata = null
      snapshot.forEach(document => {
        if (appdata === null) {
          appdata = docToInstance(document)
        } else {
          docToInstance(document).delete()
        }
      })

      callback(appdata)
    })
  }
  
  static listenAll(callback) {
    return onSnapshot(collection(db, collectionName), snapshot => {
      let list = []
      snapshot.forEach(document => {
        let res = docToInstance(document)
        list.push(res)
      })
      callback(list)
    })
  }

  async save() {
    let new_appdata = {
      application: this.application,
      parameters: this.parameters
    }

    await setDoc(doc(db, collectionName, this.id), new_appdata)
  }

  async delete() {
    await deleteDoc(doc(db, collectionName, this.id))
  }
}
